import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "transcription-and-speakers",
  courseId: "reports-from-audio",
  order: 9,
  title: "Transcription",
  subtitle: "The panel and speaker names",
  summary:
    "Every case keeps its transcript, synced to the audio. Fix a misheard word, name the speakers, and split or merge segments before you regenerate.",
  learn: [
    "Play audio from any segment and follow along",
    "Rename speakers and correct segment text",
    "Split, merge, and delete segments",
  ],
  sceneId: "transcription-and-speakers",
  tourId: "transcription-and-speakers",
  minutes: 4,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "The **Transcription** tab sits beside **Narrative** in the editor. For an interaction it shows speaker-labelled segments with timestamps, and for a narrative it shows your dictation. Click a segment to play the audio from there.",
    },
    {
      type: "steps",
      items: [
        "Open the case and click the **Transcription** tab.",
        "Click **Follow audio** so the current segment highlights as the recording plays. Click **Stop following** to scroll freely.",
        "To name a speaker, click the speaker's name on a segment, then click the pencil beside it. The **Edit Speaker Name** box opens.",
        "If the engine merged two voices, open the same speaker list and choose **Add New Speaker**, then reassign the segments. To remove a label that should not exist, click the trash icon beside it, which opens **Delete Speaker**.",
        "Open a segment's menu to Copy Transcription, Edit Transcription, Merge with Previous, Merge with Next, Split Segment, or Delete Segment. Timestamps are editable too.",
        "When the transcript is right, regenerate the narrative.",
      ],
    },
    {
      type: "paragraph",
      text: "Do the naming before you regenerate, not after. The regenerated draft then reads \"Witness Daniel Reyes stated\" instead of \"Speaker 2 stated\".",
    },
    {
      type: "callout",
      tone: "note",
      text: "Mono recordings are separated into up to four speakers. A fifth voice is folded into one of the four, so on a busy scene expect to split and reassign a few segments.",
    },
    {
      type: "paragraph",
      text: "You can also export the transcript on its own: click **Export**, then **Transcription**, and choose DOCX or TXT, with or without timestamps. \"Regenerate\" covers the regenerate step.",
    },
  ],
  related: ["regenerate-the-narrative", "narrative-vs-interaction-audio", "export-your-report"],
};

export default lesson;
